'use client';

import Skeleton from '@/app/(football)/[team]/_components/common/Skeleton';

export default function ListItemSkeleton() {
  return (
    <li className="flex w-full flex-col items-center gap-4">
      {/* Image Skeleton */}
      <Skeleton className="aspect-square" height="auto" />

      {/* Info Skeleton */}
      <div className="flex w-full flex-col items-start gap-2">
        <div className="flex w-full flex-col items-start gap-1">
          <Skeleton height={14} width="50%" />
          <Skeleton height={20} />
        </div>
        <div className="flex w-full flex-col items-start gap-1">
          <Skeleton height={18} width="70%" />
          <Skeleton height={18} width="70%" />
          <Skeleton height={14} width="50%" />
        </div>
      </div>
    </li>
  );
}
